import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Trash2 } from 'lucide-react'

interface DisconnectDialogProps {
  name: string
  open: boolean
  handleClose: (...args: any[]) => void
  handleDisconnect: (...args: any[]) => void
}

export function DisconnectDialog({ name, open, handleClose, handleDisconnect }: DisconnectDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && handleClose()}>
      <DialogContent className="max-w-2xl rounded-2xl border-2 border-warningRed p-8">
        <DialogHeader>
          <DialogTitle className="text-zinc text-2xl font-semibold font-manrope leading-tight">
            Disconnect from {name}?
          </DialogTitle>
        </DialogHeader>

        <DialogFooter className="mt-6 flex items-center gap-3 sm:justify-start">
          <Button
            onClick={() => {
              handleDisconnect()
              handleClose()
            }}
            className="w-auto min-w-[215px] h-11 px-5 py-2.5 bg-warningRed hover:bg-warningRed/90 text-white rounded shadow-inner font-semibold font-manrope"
          >
            <Trash2 className="mr-2 h-5 w-5" />
            Yes, Disconnect
          </Button>
          <Button
            onClick={handleClose}
            variant="outline"
            className="w-auto min-w-[86px] h-10 px-4 py-2.5 rounded shadow-inner border border-warningRed text-warningRed hover:bg-warningRed/10 font-semibold font-manrope"
          >
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
